import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const Whatsapp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M16 28c6.628 0 12-5.372 12-12S22.628 4 16 4 4 9.372 4 16c0 2.485.755 4.795 2.05 6.71l-2.777 6.194 6.7-2.525A11.935 11.935 0 0016 28z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        d="M13.539 14.95l.743-.86c.309-.36.386-.866.197-1.302l-1.121-2.59a.986.986 0 00-1.024-.598c-.452.056-1.027.188-1.491.47-1.91 1.155-2.15 5.437 2.11 9.045 5.283 4.477 8.597 3.533 9.853 1.872.352-.464.444-1.224.462-1.736a.813.813 0 00-.468-.763l-2.65-1.275a.903.903 0 00-1.11.27l-1.024 1.357s-1.376-.495-2.532-1.541c-1.156-1.046-1.945-2.348-1.945-2.348"
        fill="currentColor"
      />
    </g>
  </svg>
)
